import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-task-state-icon',
  templateUrl: './task-state-icon.component.html',
  styleUrls: ['./task-state-icon.component.scss']
})
export class TaskStateIconComponent {

  important: boolean;

  any: boolean;

  @Input("state") set setState(value: string) {
    this.important = value === 'IMPORTANT';
    this.any = value === 'ANY';
  }

}
